import { apiMaybe, apiRequest } from '../../services/apiClient';

function booleanQuery(name, value) {
  return value ? `?${name}=true` : '';
}

export function updateContract(contractId, payload) {
  return apiRequest(`/contracts/${contractId}`, {
    method: 'PUT',
    json: payload,
  });
}

export function markContractReviewed(contractId) {
  return apiRequest(`/contracts/${contractId}/mark-reviewed`, {
    method: 'POST',
  });
}

export function dismissContractReminder(contractId, kind, reenable) {
  return apiRequest(`/contracts/${contractId}/dismiss-${kind}`, {
    method: 'POST',
    json: { reenable },
  });
}

export function terminateContract(contractId, reason) {
  return apiRequest(`/contracts/${contractId}/terminate`, {
    method: 'POST',
    json: { reason: reason || null },
  });
}

export function publishContractToDrive(contractId) {
  return apiRequest(`/contracts/${contractId}/publish-to-drive`, {
    method: 'POST',
  });
}

// Re-run the AI key-terms pass (risks / commitments / financial terms) against
// the contract's stored document, using the active type/category criteria.
export function regenerateKeyRisks(contractId) {
  return apiRequest(`/contracts/${contractId}/regenerate-key-risks`, {
    method: 'POST',
  });
}

// Obligation docketing (doc-70): typed dated obligations on a contract.
export function listObligations(contractId) {
  return apiRequest(`/contracts/${contractId}/obligations`);
}

export function createObligation(contractId, payload) {
  return apiRequest(`/contracts/${contractId}/obligations`, {
    method: 'POST',
    json: payload,
  });
}

export function updateObligation(contractId, obligationId, payload) {
  return apiRequest(`/contracts/${contractId}/obligations/${obligationId}`, {
    method: 'PATCH',
    json: payload,
  });
}

export function deleteObligation(contractId, obligationId) {
  return apiRequest(`/contracts/${contractId}/obligations/${obligationId}`, {
    method: 'DELETE',
  });
}

export function deleteContract(contractId, { deleteDriveFolder = false } = {}) {
  return apiRequest(`/contracts/${contractId}${booleanQuery('deleteDriveFolder', deleteDriveFolder)}`, {
    method: 'DELETE',
  });
}

export function deleteContractFile(contractId, fileId, { deleteDriveFile = false } = {}) {
  return apiRequest(
    `/contracts/${contractId}/files/${fileId}${booleanQuery('deleteDriveFile', deleteDriveFile)}`,
    { method: 'DELETE' }
  );
}

export function analyzeContractUpload(payload) {
  return apiMaybe('/contracts/upload-analysis', {
    method: 'POST',
    json: payload,
  });
}

export function uploadContractFile(contractId, form) {
  return apiRequest(`/contracts/${contractId}/upload-file`, {
    method: 'POST',
    body: form,
  });
}

export function updateContractFile(contractId, fileId, payload) {
  return apiRequest(`/contracts/${contractId}/files/${fileId}`, {
    method: 'PATCH',
    json: payload,
  });
}
